import React from "react";
import { Modal } from "react-bootstrap";
import { CustomSpinner } from "@components/Spinner/SpinnerMyAccountView";
import "./ConfirmationModalStyles.scss";

interface ConfirmationModalProps {
	show: boolean;
	title: string;
	message: string;
	loading?: boolean;
	onHide: () => void;
	onConfirm: () => void;
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
	show,
	title,
	message,
	loading = false,
	onHide,
	onConfirm,
}) => {
	return (
		<Modal
			className="confirmation-modal"
			show={show}
			onHide={!loading ? onHide : undefined}
			centered
		>
			<Modal.Header closeButton={!loading}>
				<Modal.Title>{title}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<p>{message}</p>
				{loading && (
					<div className="d-flex justify-content-center mt-3">
						<CustomSpinner size={30} height={"auto"} borderSize={3} />
					</div>
				)}
			</Modal.Body>
			<Modal.Footer>
				<div className="buttons">
					<button className="cancel-btn" onClick={onHide} disabled={loading}>
						Cancelar
					</button>
					<button className="confirm-btn" onClick={onConfirm} disabled={loading}>
						{loading ? "Eliminando..." : "Confirmar"}
					</button>
				</div>
			</Modal.Footer>
		</Modal>
	);
};
